import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

type Props = {
  isMinimized: boolean;
  toggleMinimize: () => void;
  closeModal: () => void;
  isCloseButtonVisible: boolean;
};

export const StatusHeader = ({
  isMinimized,
  toggleMinimize,
  closeModal,
  isCloseButtonVisible,
}: Props) => {
  const { t } = useTranslation(['knowledge_base']);

  return (
    <div className="flex items-center justify-between px-4 pt-4 pb-2">
      <h3 className="font-medium text-foreground text-sm">{t('modals.status_modal.title')}</h3>
      <div className="flex items-center">
        <Button
          variant="custom"
          className="!border-none"
          size="icon"
          onClick={toggleMinimize}
          aria-label={
            isMinimized
              ? t('modals.status_modal.button.expand')
              : t('modals.status_modal.button.minimize')
          }
        >
          <Icon
            icon={isMinimized ? 'mingcute:up-line' : 'mingcute:down-line'}
            className="!h-4.5 !w-4.5 text-foreground-subtle"
          />
        </Button>
        {isCloseButtonVisible && (
          <Button
            variant="custom"
            className="!border-none"
            size="icon"
            onClick={closeModal}
            aria-label={t('modals.status_modal.button.close')}
          >
            <Icon icon="mingcute:close-line" className="!h-4.5 !w-4.5 text-foreground-subtle" />
          </Button>
        )}
      </div>
    </div>
  );
};
